export const IconType = Object.freeze({
  TECHNOLOGY: "technology",
  TWITTER: "twitter",
  WEB: "web",
  SHARE: "share",
  HOME: "home",
});
